import config from 'config'
import RoutingMenu from 'LIBRARY/CommonResources/RoutingMenu/RoutingMenu'
import React from 'react'
import "./Requisition.css"

export const Requisition = () => {
  return (
        <>
        <RoutingMenu activeScreen="resourceRequisition" />
    <div className=''>

        <iframe
            src={`${config.RootUrl}/faculty/library/requisitionAproval/Requisition.php?isIframe=true`}
            className="iframe col-md-12"
        >
        </iframe>
    </div>
    </>
  )
}
